const monthToSeason = (monthIndex) => {
  if (monthIndex >= 2 && monthIndex <= 4) return 'Summer';
  if (monthIndex >= 5 && monthIndex <= 8) return 'Monsoon';
  if (monthIndex >= 9 && monthIndex <= 10) return 'Autumn';
  return 'Winter';
};

export const getCurrentSeason = (date = new Date()) => monthToSeason(date.getMonth());

export const SEASON_THEMES = {
  Summer: {
    title: 'Summer Harvest',
    gradient: 'linear-gradient(135deg, #f97316, #facc15)',
    panel: '#fff7ed',
    accent: '#c2410c',
    surface: '#7c2d12',
    surfaceSoft: 'rgba(255, 237, 213, 0.88)',
    chipBg: 'rgba(255,255,255,0.16)',
    chipText: '#fff7ed',
    glow: 'rgba(251, 146, 60, 0.28)',
    orbOne: 'rgba(251, 146, 60, 0.38)',
    orbTwo: 'rgba(253, 224, 71, 0.25)',
    atmosphere: 'linear-gradient(180deg, #fff7ed 0%, #ffedd5 42%, #fde68a 100%)',
  },
  Monsoon: {
    title: 'Monsoon Harvest',
    gradient: 'linear-gradient(135deg, #0ea5e9, #0f766e)',
    panel: '#ecfeff',
    accent: '#0f766e',
    surface: '#134e4a',
    surfaceSoft: 'rgba(236, 254, 255, 0.9)',
    chipBg: 'rgba(255,255,255,0.15)',
    chipText: '#ecfeff',
    glow: 'rgba(6, 182, 212, 0.24)',
    orbOne: 'rgba(14, 165, 233, 0.28)',
    orbTwo: 'rgba(15, 118, 110, 0.22)',
    atmosphere: 'linear-gradient(180deg, #ecfeff 0%, #cffafe 38%, #a7f3d0 100%)',
  },
  Autumn: {
    title: 'Autumn Harvest',
    gradient: 'linear-gradient(135deg, #ca8a04, #7c2d12)',
    panel: '#fffbeb',
    accent: '#92400e',
    surface: '#713f12',
    surfaceSoft: 'rgba(255, 251, 235, 0.9)',
    chipBg: 'rgba(255,255,255,0.14)',
    chipText: '#fffbeb',
    glow: 'rgba(202, 138, 4, 0.22)',
    orbOne: 'rgba(245, 158, 11, 0.28)',
    orbTwo: 'rgba(120, 53, 15, 0.18)',
    atmosphere: 'linear-gradient(180deg, #fffbeb 0%, #fef3c7 42%, #fed7aa 100%)',
  },
  Winter: {
    title: 'Winter Harvest',
    gradient: 'linear-gradient(135deg, #2563eb, #4338ca)',
    panel: '#eff6ff',
    accent: '#1e3a8a',
    surface: '#1e3a8a',
    surfaceSoft: 'rgba(239, 246, 255, 0.9)',
    chipBg: 'rgba(255,255,255,0.15)',
    chipText: '#eff6ff',
    glow: 'rgba(96, 165, 250, 0.24)',
    orbOne: 'rgba(96, 165, 250, 0.25)',
    orbTwo: 'rgba(129, 140, 248, 0.2)',
    atmosphere: 'linear-gradient(180deg, #eff6ff 0%, #dbeafe 42%, #c7d2fe 100%)',
  },
};

export const INDIA_STATES = [
  { name: 'Telangana', region: 'South' },
  { name: 'Andhra Pradesh', region: 'South' },
  { name: 'Tamil Nadu', region: 'South' },
  { name: 'Karnataka', region: 'South' },
  { name: 'Kerala', region: 'South' },
  { name: 'Maharashtra', region: 'West' },
  { name: 'Gujarat', region: 'West' },
  { name: 'Rajasthan', region: 'West' },
  { name: 'Madhya Pradesh', region: 'Central' },
  { name: 'Chhattisgarh', region: 'Central' },
  { name: 'Uttar Pradesh', region: 'North' },
  { name: 'Punjab', region: 'North' },
  { name: 'Haryana', region: 'North' },
  { name: 'Bihar', region: 'East' },
  { name: 'West Bengal', region: 'East' },
  { name: 'Odisha', region: 'East' },
];

const seasonMap = {
  Summer: {
    North: {
      fruits: ['Mango', 'Litchi', 'Watermelon'],
      vegetables: ['Bottle Gourd', 'Cucumber', 'Okra'],
    },
    South: {
      fruits: ['Mango', 'Papaya', 'Banana'],
      vegetables: ['Drumstick', 'Snake Gourd', 'Cucumber'],
    },
    East: {
      fruits: ['Mango', 'Jackfruit', 'Pineapple'],
      vegetables: ['Ridge Gourd', 'Pumpkin', 'Okra'],
    },
    West: {
      fruits: ['Mango', 'Muskmelon', 'Guava'],
      vegetables: ['Cluster Beans', 'Bottle Gourd', 'Okra'],
    },
    Central: {
      fruits: ['Mango', 'Watermelon', 'Papaya'],
      vegetables: ['Bitter Gourd', 'Pumpkin', 'Cucumber'],
    },
  },
  Monsoon: {
    North: {
      fruits: ['Pear', 'Plum', 'Jamun'],
      vegetables: ['Spinach', 'Cabbage', 'Beans'],
    },
    South: {
      fruits: ['Banana', 'Guava', 'Pineapple'],
      vegetables: ['Ash Gourd', 'Beans', 'Pumpkin'],
    },
    East: {
      fruits: ['Guava', 'Banana', 'Pineapple'],
      vegetables: ['Colocasia', 'Okra', 'Cabbage'],
    },
    West: {
      fruits: ['Guava', 'Pear', 'Papaya'],
      vegetables: ['Spinach', 'Bottle Gourd', 'Beans'],
    },
    Central: {
      fruits: ['Guava', 'Papaya', 'Banana'],
      vegetables: ['Spinach', 'Cabbage', 'Ridge Gourd'],
    },
  },
  Autumn: {
    North: {
      fruits: ['Apple', 'Pomegranate', 'Orange'],
      vegetables: ['Carrot', 'Radish', 'Cauliflower'],
    },
    South: {
      fruits: ['Pomegranate', 'Banana', 'Orange'],
      vegetables: ['Beans', 'Cauliflower', 'Beetroot'],
    },
    East: {
      fruits: ['Orange', 'Guava', 'Pomegranate'],
      vegetables: ['Cauliflower', 'Carrot', 'Spinach'],
    },
    West: {
      fruits: ['Orange', 'Pomegranate', 'Apple'],
      vegetables: ['Cauliflower', 'Carrot', 'Peas'],
    },
    Central: {
      fruits: ['Orange', 'Apple', 'Pomegranate'],
      vegetables: ['Cauliflower', 'Carrot', 'Radish'],
    },
  },
  Winter: {
    North: {
      fruits: ['Orange', 'Apple', 'Strawberry'],
      vegetables: ['Carrot', 'Peas', 'Spinach'],
    },
    South: {
      fruits: ['Orange', 'Guava', 'Strawberry'],
      vegetables: ['Carrot', 'Beans', 'Beetroot'],
    },
    East: {
      fruits: ['Orange', 'Apple', 'Guava'],
      vegetables: ['Peas', 'Carrot', 'Spinach'],
    },
    West: {
      fruits: ['Orange', 'Strawberry', 'Apple'],
      vegetables: ['Peas', 'Carrot', 'Cabbage'],
    },
    Central: {
      fruits: ['Orange', 'Apple', 'Guava'],
      vegetables: ['Peas', 'Carrot', 'Spinach'],
    },
  },
};

export const getRegionFromState = (state) => {
  const found = INDIA_STATES.find((item) => item.name.toLowerCase() === String(state || '').toLowerCase());
  return found?.region || 'South';
};

export const getRegionFromCoordinates = (latitude, longitude) => {
  const lat = Number(latitude);
  const lng = Number(longitude);

  if (Number.isNaN(lat) || Number.isNaN(lng)) return 'South';

  if (lat >= 25) return 'North';
  if (lng >= 86) return 'East';
  if (lng <= 74) return 'West';
  if (lat >= 20 && lat < 25) return 'Central';
  return 'South';
};

export const getSeasonalRecommendations = (season, region, mode = 'all') => {
  const scoped = seasonMap[season]?.[region] || seasonMap[season]?.South || { fruits: [], vegetables: [] };
  if (mode === 'fruits') return scoped.fruits;
  if (mode === 'vegetables') return scoped.vegetables;
  return [...scoped.fruits, ...scoped.vegetables];
};

export const matchesProduceName = (product, names) => {
  const lower = String(product?.name || '').toLowerCase();
  return names.some((name) => lower.includes(String(name).toLowerCase()));
};
